/** CMS menu location stored in the API (FOOTER_CONTENT = the single site footer). */
export const FOOTER_MENU_LOCATION = 'FOOTER_CONTENT' as const;

export const MENU_LOCATIONS = [
  { id: 'HEADER_PRIMARY', label: 'Header - Primary', desc: 'Main navigation bar' },
  {
    id: 'HEADER_SECONDARY',
    label: 'Header - Secondary',
    desc: 'Top utility links (Login, MICE, Blog)',
  },
  {
    id: FOOTER_MENU_LOCATION,
    label: 'Footer',
    desc: 'One footer menu - add sections (yellow headings) and links inside each section',
  },
  { id: 'MOBILE_DRAWER', label: 'Mobile Drawer', desc: 'Mobile menu' },
] as const;

export type MenuLocationId = (typeof MENU_LOCATIONS)[number]['id'];
